import { Component } from '@theme/component';
import { buildQuestionnairePayload, sendQuestionnaire, recordQuestionnaireCompletion } from './zu-pre-discovery-core.js';

class PreDiscoveryQuestionnaire extends Component {
  requiredRefs = ['form', 'fields', 'submit', 'status'];
  #listeners;
  #request;
  #pending = false;
  #completed = false;

  connectedCallback() {
    super.connectedCallback();
    this.#listeners?.abort();
    this.#listeners = new AbortController();
    this.refs.form.addEventListener('submit', this.handleSubmit, { signal: this.#listeners.signal });
    this.refs.fields.disabled = this.#completed;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#listeners?.abort();
    this.#request?.abort();
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    if (this.#pending || this.#completed || !this.refs.form.reportValidity()) return;
    const { form, fields, submit, status } = this.refs;
    if (this.dataset.enabled !== 'true') {
      status.textContent = this.dataset.preview;
      status.focus();
      return;
    }
    this.#pending = true;
    const originalLabel = submit.textContent;
    const payload = buildQuestionnairePayload(new FormData(form), window.location.href, document.title);
    this.#request = new AbortController();
    const request = this.#request;
    const timer = setTimeout(() => request.abort(), 20000);
    fields.disabled = true;
    form.setAttribute('aria-busy', 'true');
    submit.textContent = this.dataset.sending;
    status.textContent = '';
    try {
      const result = await sendQuestionnaire(this.dataset.portalId, this.dataset.formId, payload, request.signal);
      if (!this.isConnected) return;
      if (result.success) {
        this.#completed = true;
        form.hidden = true;
        status.textContent = `${this.dataset.success} ${this.dataset.successDetail}`;
        recordQuestionnaireCompletion(window, this.dataset.formId);
      } else {
        status.textContent = this.dataset[result.reason] || this.dataset.error;
      }
      status.focus();
    } catch {
      if (this.isConnected) {
        status.textContent = this.dataset.error;
        status.focus();
      }
    } finally {
      clearTimeout(timer);
      this.#pending = false;
      if (this.#request === request) this.#request = undefined;
      fields.disabled = this.#completed || !this.isConnected;
      form.removeAttribute('aria-busy');
      submit.textContent = originalLabel;
    }
  };
}

if (!customElements.get('zu-pre-discovery')) customElements.define('zu-pre-discovery', PreDiscoveryQuestionnaire);
